// Mobile nav drawer
function toggleNav(status, scope) {
  document.documentElement.classList.toggle("js-has-open-nav");

  if (status === "open") {
    scope.addEventListener("transitionend", () => {
      scope.querySelector(".js-close").focus();
    });
  } else if (status === "close") {
    scope.querySelector(".js-open").focus();
  }
}

// Open & close menu on buttons click
const menu = document.querySelector(".navigation");
const openButton = document.querySelector(".js-open");
const closeButton = menu.querySelector(".js-close");

openButton?.addEventListener("click", () => {
  toggleNav("open", menu);
});

closeButton?.addEventListener("click", () => {
  toggleNav("close", menu);
});

// Close when clicking outside the nav drawer
document.addEventListener("click", (e) => {
  const navWrapper = document.querySelector(".navigation-list-wrapper");
  if (
    document.documentElement.classList.contains("js-has-open-nav") &&
    !navWrapper.contains(e.target) &&
    !e.target.closest(".js-open")
  ) {
    toggleNav("close", menu);
  }
});

// close menu if Esc is pressed
document.addEventListener("keydown", (event) => {
  if (
    event.key === "Escape" &&
    document.documentElement.classList.contains("js-has-open-nav")
  ) {
    document.documentElement.classList.remove("js-has-open-nav");
  }
});

// Dropdown
function initAboutSubmenu() {
  const btn = document.querySelector(".js-submenu-toggle");
  if (!btn) {
    return;
  }

  const listId = btn.getAttribute("aria-controls");
  const list = document.getElementById(listId);
  if (!list) {
    return;
  }

  // Initialize from aria-expanded
  const isOpen = btn.getAttribute("aria-expanded") === "true";
  list.classList.toggle("is-open", isOpen);
  list.hidden = !isOpen;
  list.classList.remove("is-active");

  // Toggle open/close on click
  btn.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    const openNow = btn.getAttribute("aria-expanded") === "true";
    const next = !openNow;
    btn.setAttribute("aria-expanded", String(next));
    list.classList.toggle("is-open", next);
    list.hidden = !next;
  });

  // Click outside closes submenu
  document.addEventListener("click", (e) => {
    if (!btn.contains(e.target) && !list.contains(e.target)) {
      if (btn.getAttribute("aria-expanded") === "true") {
        btn.setAttribute("aria-expanded", "false");
        list.classList.remove("is-open");
        list.hidden = true;
      }
    }
  });

  // Esc closes submenu and restores focus
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && btn.getAttribute("aria-expanded") === "true") {
      btn.setAttribute("aria-expanded", "false");
      list.classList.remove("is-open");
      list.hidden = true;
      btn.focus();
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAboutSubmenu);
} else {
  initAboutSubmenu();
}

// Scrolled header
function updateScrolledHeader() {
  const header = document.querySelector(".site-header-container");
  if (window.scrollY > 50) {
    header.classList.add("is-scrolled");
  } else {
    header.classList.remove("is-scrolled");
  }
}

window.addEventListener("scroll", updateScrolledHeader);

// Run on page load
updateScrolledHeader();

// Skip links to #main
document
  .getElementById("skip-to-content")
  .addEventListener("click", function (e) {
    e.preventDefault();
    const target = document.getElementById("main");
    target.setAttribute("tabindex", "-1");
    target.focus();
  });

// Remove js-has-open-nav when window width goes above lg breakpoint (992px)
window.addEventListener("resize", function () {
  if (window.innerWidth >= 992) {
    document.documentElement.classList.remove("js-has-open-nav");
  }
});
